import { extractDomain } from 'src/utils/helpers/extractDomain';

export const mapLinks = (arr, type = 'link') => {
	return (arr ?? []).map((item, index) => ({
		id: `${type}-${index}`,
		label: type === 'email' ? item : extractDomain(item),
		link: { to: type === 'email' ? `mailto:${item}` : item },
	}));
};
